import { css, styled } from '@creditas-ui/system'

const Wrapper = styled.div(
  ({ shouldHide }) => css`
    ${shouldHide && 'display: none;'}
  `,
)

export { Wrapper }
